import React, { Component } from 'react'
import { Row, Table, message, Button, Modal, Spin } from "antd"
import closeIcon from "app/styles/images/sp/close.svg"
import { observer } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import "./Index.scss"

@observer
export default class exportGroupModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      exportModalShowed: false,
      downLoadText: '',
    }
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  handleExportByUrl = (res) => {
    const { onClose } = this.props
    const exportDataUrl = res.url
    this.setState({
      exportModalShowed: false,
    })
    onClose()
    if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
    let a = document.createElement("iframe")
    a.setAttribute("src", exportDataUrl)
    a.setAttribute("id", "export-a-tag")
    a.setAttribute("style", "display:none;")
    if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
    return Promise.resolve(res)
  }
  
  getTemplateId = (selected) => {
    const { templates } = this.props
    const downLoadTemplate = templates.find((item) =>
      selected.appGroupName === item.appGroupName && item.type === "group" && item.format === "pdf")
    return downLoadTemplate ? downLoadTemplate.id: null
  }

  onExportPdfClick = () => {
    const { store: { exportBatchPdfStatus, selectedRows,selectedRowKeys } } = this.props
    if (selectedRowKeys.length <= 0) {
      message.error('请选择需要导出的数据')
      return
    }
    
    const data = selectedRows.map(selected => ({
      groupId: selected.groupId,
      templateId: this.getTemplateId(selected),
    }))

    this.setState({
      exportModalShowed: true,
      downLoadText: '正在为您动态组装PDF，请您稍等...'
    })

    exportBatchPdfStatus(data)
      .then(res => {
        this.exportBatchStep2(res.id)
      },err => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
    })
  }

  exportBatchStep2 = (downloadId) => { 
    const { store: { exportBatchPdf } } = this.props
    exportBatchPdf(downloadId)
      .then(res => {
        if (res.status !== 0) {
          setTimeout(() => this.exportBatchStep2(downloadId), 1000)
          return
        }
        this.handleExportByUrl(res)
      }, err => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
    })
  }

  handleBatchExport = () => {
    const { type } = this.props
    const { exportBatchGroup, exportBatchLink, selectedRowKeys } = this.props.store
    if (selectedRowKeys.length <= 0) {
      message.error('请选择需要导出的数据')
      return
    }
    
    this.setState({
      exportModalShowed: true,
      downLoadText: '正在导出中，请稍等。。。'
    })

    type === 'group' ?
      exportBatchGroup(selectedRowKeys).then(res => {
        this.handleExportByUrl(res)
      }, err => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
        return Promise.reject(err)
      }) :
      exportBatchLink(selectedRowKeys)
        .then(
          res => {
            this.handleExportByUrl(res)
          },
          err => {
            message.error("导出失败，请您重试！")
            this.setState({
              exportModalShowed: false,
            })
            return Promise.reject(err)
          }
        )
  }

  render() {
    const { onClose, type } = this.props
    const {
      list:
      {
        tableData,
        totalCount,
        currentPageIndex,
        queryMap
      },
      onSelect,
      onSelectAll,
      selectedRowKeys
    } = this.props.store
    
    const rowSelection = {
      selectedRowKeys,
      onSelect: onSelect,
      onSelectAll: onSelectAll
    }

    const columns = [{
      title: "数据类型",
      className: "ta-l",
      dataIndex: "appName",
    }, {
      title: "所在家系",
      className: "ta-l",
      dataIndex: "groupName",
    }, {
      title: "报告数量",
      className: "ta-l",
      dataIndex: "totalDataCount",
    }, {
      title: "已删除报告数量",
      className: "ta-l",
      dataIndex: "deletedDataCount",
    }, {
      title: "创建时间",
      className: "ta-l",
      dataIndex: "createTime",
    }]

    return (
      <MaterialModal
        title={type === 'group' ? "组数据导出列表" : "组数据导出链接"
        }
        visible
        width={1000}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <Button
              type="primary"
              size="default"
              className="export-btn"
              onClick={this.handleBatchExport}
            >
              导出Excel 
            </Button>
            {type === 'group' ? 
              <Button
                type="primary"
                size="default"
                className="export-btn"
                onClick={this.onExportPdfClick}
              >
                导出Pdf
              </Button>
              :''
            }
          </Row>
        )
        }
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Table
          columns={columns}
          rowSelection={rowSelection}
          dataSource={tableData.slice()}
          rowKey={record => record.groupId}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">{ this.state.downLoadText }</div>
        </Modal>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/report/ExportGroupModal.js